import React from 'react';
import { useTranslation } from 'react-utilities';
import { NAPageItemConfigType } from '../ConfigTypes';
import getRobloxUrl from '../../utils/getRobloxUrl';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { EventTypes } from '../../services/eventConstants';
import { COMMUNITY_STANDARDS_URL } from '../../utils/constants';

/**
 * Content and page link about our community standards. Always shown
 */
const CommunityStandardsPageItem = (): JSX.Element => {
  const { translate } = useTranslation();

  const translateWithLink = makeTranslateWithLink(translate);
  return (
    <div data-testid='community-standards'>
      {translateWithLink(
        'Description.CommunityStandards',
        COMMUNITY_STANDARDS_URL,
        undefined,
        EventTypes.CommunityGuidelineClicked
      )}
    </div>
  );
};

const CommunityStandardsPageItemConfig: NAPageItemConfigType = {
  getIsVisible: () => {
    return true;
  },
  renderComponent: CommunityStandardsPageItem,
  configName: 'community-standards'
};

export default CommunityStandardsPageItemConfig;
